import { createSlice } from '@reduxjs/toolkit'

import { bootstrapAdmin } from '@/thunks/admins/bootstrap'
import { retrieveBranding } from '@/thunks/branding/retrieve'
import { updateBranding } from '@/thunks/branding/update'

type BrandingState = {
  logo?: string
  color?: string
  domain?: string
  domainIsVerified?: boolean
}

const initialState: BrandingState = {}

const slice = createSlice({
  name: 'branding',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(bootstrapAdmin.fulfilled, (_, action) => action.payload.data.branding)
    builder.addCase(updateBranding.fulfilled, (_, action) => action.payload.data)
    builder.addCase(retrieveBranding.fulfilled, (_, action) => action.payload.data)
  },
})

export default slice
